import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { TextInput } from '@streamr/tv-ui';
import { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { LobbyService } from '../../services/lobby/LobbyService';
import { StreamrAppService } from '../../services/streamrapp/StreamrAppService';
import { UserService } from '../../services/user/UserService';
import { Button } from '../Button';
import { RequestToSpeakButton } from '../broadcaster/RequestToSpeakButton';
import { LogoLink } from '../shared/LogoLink';
export function Lobby() {
    const lobbyView = LobbyService.getOutput().useLobbyView();
    if (lobbyView === 'none')
        return null;
    return (_jsxs(LobbyRoot, { onClick: () => StreamrAppService.getNotificationInterface().notifyUserGesture(), children: [_jsx(LobbyLogo, { children: _jsx(LogoLink, {}) }), _jsxs(LobbyContent, { children: [lobbyView === 'name-entry' && _jsx(NameEntryView, {}), lobbyView === 'connecting' && _jsx(ConnectingView, {}), lobbyView === 'request-to-speak' && _jsx(RequestToSpeakButton, {})] })] }));
}
function NameEntryView() {
    const storedDisplayName = UserService.getOutput().useLocalDisplayName();
    const [name, setName] = useState(storedDisplayName);
    const canJoin = name.trim().length > 0;
    const handleJoin = () => {
        if (!canJoin)
            return;
        LobbyService.getNotificationInterface().notifyNameEntered(name.trim());
    };
    return (_jsxs(_Fragment, { children: [_jsx(ReadyText, { children: "Enter your name to start" }), _jsx(NameInput, { placeholder: "Your name", value: name, onChange: (e) => setName(e.target.value) }), _jsx(JoinButton, { type: "button", kind: "primary", size: "big", padding: "normal", disabled: !canJoin, onClick: handleJoin, children: "Start" })] }));
}
function ConnectingView() {
    return (_jsxs(ConnectingText, { children: ["Connecting", _jsxs(AnimatedDots, { children: [_jsx(Dot, { "$delay": 0 }), _jsx(Dot, { "$delay": 1 }), _jsx(Dot, { "$delay": 2 })] })] }));
}
const LobbyRoot = styled.div `
    flex: 1;
    min-height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--tv-ui-color-14);
    position: relative;
`;
const LobbyLogo = styled.div `
    position: absolute;
    top: 0.75rem;
    left: 1rem;

    @media (min-width: 32.5rem) {
        top: 1rem;
        left: 2rem;
    }
`;
const LobbyContent = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
`;
const ReadyText = styled.span `
    font-size: 1.25rem;
    font-weight: 500;
    color: white;
`;
const NameInput = styled(TextInput) `
    width: 22rem;
`;
const JoinButton = styled(Button) `
    width: 22rem;
`;
const ConnectingText = styled.span `
    display: flex;
    align-items: baseline;
    font-size: 1.25rem;
    font-weight: 500;
    color: white;
`;
const dotBounce = keyframes `
    0%, 80%, 100% {
        opacity: 0;
    }
    40% {
        opacity: 1;
    }
`;
const AnimatedDots = styled.span `
    display: inline-flex;
    margin-left: 2px;
    gap: 2px;
`;
const Dot = styled.span `
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: white;
    animation: ${dotBounce} 1.4s infinite;
    animation-delay: ${(p) => p.$delay * 0.2}s;
`;
